import React from 'react';
import { useVersionSelector } from '../hooks/useVersionSelector';
import HomePage from '../pages/HomePage';
import AuditedHomePage from '../pages/audited/AuditedHomePage';
import AwesomeHomePage from '../pages/awesome/AwesomeHomePage';

/**
 * Komponent routujący do odpowiedniej wersji strony głównej
 * na podstawie query param ?version=X
 *
 * Obsługiwane wersje:
 * - original (domyślna) - oryginalna strona
 * - audited - wersja z poprawkami treści i UX
 * - awesome - nowy design inspirowany Teachable/Skillshare
 */
const VersionRouter: React.FC = () => {
  const version = useVersionSelector();

  switch (version) {
    case 'audited':
      return <AuditedHomePage />;
    case 'awesome':
      return <AwesomeHomePage />;
    default:
      return <HomePage />;
  }
};

export default VersionRouter;
